import React from 'react'
import OrderListItem, { IOrderListItemForwardProps } from './OrderListItem'
import { IOrder } from './IOrder'

interface IOrdersListProps extends IOrderListItemForwardProps {
  orders: IOrder[]
}

const OrdersList: React.FC<IOrdersListProps> = ({ orders, ...other }) => {
  return (
    <div>
      {orders.map((bidItem) => {
        return <OrderListItem key={bidItem.order_id} order={bidItem} {...other} />
      })}
    </div>
  )
}
export default OrdersList
